const features = [
  {
    title: '精准漫画分类',
    desc: '从韩漫推荐到日漫大全国漫排行榜，多维度精准分类，让你三秒找到心仪漫画。告别漫无目的的翻找，漫画分类让发现好作品变得简单高效。',
    icon: 'ri-stack-line',
    color: 'bg-primary-100 text-primary-500',
  },
  {
    title: '每日同步更新',
    desc: '热门韩漫、日漫、国漫每日同步最新章节，更新速度业界领先。无论是连载追更还是新作上线，你总能在第一时间获取最新漫画资源。',
    icon: 'ri-speed-up-line',
    color: 'bg-accent-100 text-accent-500',
  },
  {
    title: '海量漫画大全',
    desc: '收录12000+部漫画作品，覆盖全部分类漫画类型。从经典名作到冷门佳作，从长篇连载到独立短篇，漫画大全一应俱全满足各类读者。',
    icon: 'ri-database-2-line',
    color: 'bg-secondary-100 text-secondary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">平台优势</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            <strong>土豪漫画网</strong>的核心特色，让漫画阅读体验更加出色
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-[1000px] mx-auto">
          {features.map((f) => (
            <div
              key={f.title}
              className="group p-6 md:p-8 bg-background-50 border border-background-200/60 rounded-xl hover:border-primary-200/60 transition-all cursor-pointer text-center"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-2xl flex items-center justify-center ${f.color}`}>
                <i className={`${f.icon} text-2xl`}></i>
              </div>
              <h3 className="font-serif font-semibold text-base md:text-lg text-foreground-900 mb-3 group-hover:text-primary-500 transition-colors">
                {f.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}